import React, { useEffect, useState } from "react";
import { createBatch, updateBatch } from "../../../api/BatchApi";

export default function ProductBatchForm({ closeForm, reloadData, editData }) {
  const [formData, setFormData] = useState({
    productCode: "",
    productName: "",
    batchNumber: "",
    manufacturingDate: "",
    expiryDate: "",
    country: "EU",
    thirdPartySampling: false,
    batchSizeKgs: "",
    batchType: "ORGANIC",
    complianceJson: ""
  });

  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [existingReports, setExistingReports] = useState({});


  const defaultCompliance = [
  { item: "Organic", regulation: "Regulation (EC) No 834/2007", status: "NO" },
  { item: "Food Safety", regulation: "Regulation (EC) No 178/2002", status: "NO" },
  { item: "Hygiene", regulation: "Regulation (EC) No 852/2004", status: "NO" },
  { item: "Allergen", regulation: "Regulation (EC) No 1169/2011", status: "NO" },
  { item: "Microbiology", regulation: "Regulation (EC) No 2073/2005", status: "NO" },
  { item: "Contaminants", regulation: "Regulation (EC) No 1881/2006", status: "NO" },
  { item: "Pesticides", regulation: "Regulation (EC) No 396/2005", status: "NO" },
  { item: "Solvent", regulation: "Directive 2009/32/EC", status: "NO" },
  { item: "GMO", regulation: "Regulation (EC) No 1829/2003, Regulation (EC) No 1830/2003", status: "NO" },
  { item: "Packing", regulation: "Regulation (EC) No 1935/2004, Regulation (EC) No 10/2011", status: "NO" },
  { item: "Ionisation / Radiation", regulation: "Directive 1999/2/EC", status: "NO" },
  { item: "TSE/BSE", regulation: "Regulation (EC) No 999/2001", status: "NO" },
  { item: "Food Additives", regulation: "Regulation (EC) No 231/2012, Regulation (EC) No 1333/2008", status: "NO" },
  { item: "PCB", regulation: "Regulation (EC) No 1259/2011", status: "NO" },
  { item: "PAH", regulation: "Regulation (EC) No 2005/108", status: "NO" }
];


  const [compliance, setCompliance] = useState(defaultCompliance);

useEffect(() => {
  if (editData) {
    setFiles({});

    setFormData({
      productCode: editData.productCode || "",
      productName: editData.productName || "",
      batchNumber: editData.batchNumber || "",
      manufacturingDate: editData.manufacturingDate || "",
      expiryDate: editData.expiryDate || "",
      country: editData.country || "EU",
      thirdPartySampling: editData.thirdPartySampling ?? false,
      batchSizeKgs:editData.batchSizeKgs || "",
      batchType: editData.batchType || "ORGANIC"
    });

    // compliance
    if (editData.complianceJson) {
      try {
        setCompliance(JSON.parse(editData.complianceJson));
      } catch {
        setCompliance(defaultCompliance);
      }
    }

    // 🔥 REPORTS FIX
    if (editData?.reports) {
  setExistingReports(editData.reports);
} else {
  setExistingReports({});
}


  } else {
    // create mode reset
    setFiles({});
    setExistingReports({});
    setCompliance(defaultCompliance);

    setFormData({
      productCode: "",
      productName: "",
      batchNumber: "",
      manufacturingDate: "",
      expiryDate: "",
      country: "EU",
      thirdPartySampling: false,
      batchSizeKgs: "",
      batchType: "ORGANIC",
      complianceJson: ""
    });
  }
}, [editData]);


 const handleChange = (e) => {

  setError("");

  const updatedForm = {
    ...formData,
    [e.target.name]: e.target.value
  };

  setFormData(updatedForm);

 const shouldShowTC =
  updatedForm.batchType === "ORGANIC";

const shouldShowHealthCert =
  updatedForm.country === "EU";

// remove hidden TC
if (!shouldShowTC) {

  setFiles(prev => {
    const updated = { ...prev };
    delete updated.TC;
    return updated;
  });
}

// remove hidden Health Cert
if (!shouldShowHealthCert) {

  setFiles(prev => {
    const updated = { ...prev };
    delete updated.healthCert;
    return updated;
  });
}
};

  const handleFile = (name, file) => setFiles(prev => ({ ...prev, [name]: file }));

  const toggleCompliance = (index, checked) => {
    const updated = [...compliance];
    updated[index].status = checked ? "YES" : "NO";
    setCompliance(updated);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const payload = new FormData();

    const dto = {
      productCode: formData.productCode,
      productName: formData.productName,
      batchNumber: formData.batchNumber,
      manufacturingDate: formData.manufacturingDate,
      expiryDate: formData.expiryDate,
      country: formData.country,
      thirdPartySampling: formData.thirdPartySampling,
      batchSizeKgs: formData.batchSizeKgs,
      batchType: formData.batchType,
      complianceJson: JSON.stringify(compliance)
    };

    payload.append("batchData", JSON.stringify(dto));

    Object.keys(files).forEach(key => {
      if (files[key]) payload.append(key, files[key]);
    });

    if (editData) {
      await updateBatch(editData.id, payload);
    } else {
      await createBatch(payload);
    }

    reloadData();
    closeForm();

  } catch (err) {
    setError(err.response?.data?.message || "Failed to save batch");
  } finally {
    setLoading(false);
  }
};


 const shouldShowTC =
  formData.batchType === "ORGANIC";

const shouldShowHealthCert =
  formData.country === "EU";

const reportFields = [

  ...(shouldShowTC
    ? [{ id: "TC", label: "Transaction Cert (TC)" }]
    : []),

  ...(shouldShowHealthCert
    ? [{ id: "healthCert", label: "Health Certificate" }]
    : []),

  { id: "pesticides", label: "Pesticide" },
  { id: "microbiology", label: "Microbiology" },
  { id: "heavyMetal", label: "Heavy Metal" },
  { id: "ETO", label: "ETO" },
  { id: "efficacy", label: "Efficacy" },
  { id: "internalCoA", label: "Internal CoA" },
  { id: "MSDS", label: "MSDS Sheet" }
];

  return (
    <div className="modal d-block" style={{ zIndex: 1070 }}>
      <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 shadow-sm" onClick={closeForm}></div>
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          
          {/* HEADER */}
          <div className="modal-header bg-white px-4 pt-4 border-0">
            <div>
              <h5 className="fw-bold mb-0 text-primary text-uppercase" style={{ letterSpacing: '1px' }}>
                Batch Registration Form
              </h5>
            </div>
            <button className="btn-close shadow-none" onClick={closeForm}></button>
          </div>

          <form onSubmit={handleSubmit} className="modal-body p-4 bg-light bg-opacity-50">
            {/* SECTION 1: GENERAL INFO */}
            <div className="card border-0 shadow-sm rounded-3 mb-4">
              <div className="card-body">
                <h6 className="fw-bold mb-3 small text-uppercase text-secondary border-bottom pb-2">Batch Details</h6>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">PRODUCT CODE *</label>
                    <input name="productCode" className="form-control form-control-sm bg-light" value={formData.productCode} onChange={handleChange} required />
                  </div>
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">PRODUCT NAME *</label>
                    <input name="productName" className="form-control form-control-sm bg-light" value={formData.productName} onChange={handleChange} required />
                  </div>
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">BATCH NUMBER *</label>
                    <input name="batchNumber" className="form-control form-control-sm bg-light fw-bold" value={formData.batchNumber} onChange={handleChange} required disabled={!!editData} />
                  </div>
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">MANUFACTURING DATE</label>
                    <input type="date" name="manufacturingDate" className="form-control form-control-sm bg-light" value={formData.manufacturingDate} onChange={handleChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">EXPIRY DATE</label>
                    <input type="date" name="expiryDate" className="form-control form-control-sm bg-light" value={formData.expiryDate} onChange={handleChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="tiny-text fw-bold text-muted">DESTINATION COUNTRY</label>
                    <select name="country" className="form-select form-select-sm bg-light" value={formData.country} onChange={handleChange}>
                      <option value="EU">European Union (EU)</option>
                      <option value="USA">United States (USA)</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                      <label className="tiny-text fw-bold text-muted">THIRD PARTY SAMPLING</label>
                      <select
                        name="thirdPartySampling"
                        className="form-select form-select-sm bg-light"
                        value={formData.thirdPartySampling}
                        onChange={(e)=>setFormData({
                          ...formData,
                          thirdPartySampling: e.target.value === "true"
                        })}
                      >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="tiny-text fw-bold text-muted">BATCH SIZE (KGS)</label>
                      <input
                        name="batchSizeKgs"
                        type="number"
                        className="form-control form-control-sm bg-light"
                        value={formData.batchSizeKgs}
                        onChange={handleChange}
                      />
                    </div>

                </div>
              </div>
            </div>

            <div className="row g-4">
              {/* SECTION 2: COMPLIANCE CHECKLIST */}
              <div className="col-lg-6">
                <div className="card border-0 shadow-sm rounded-3 h-100">
                  <div className="card-body">
                    <h6 className="fw-bold mb-3 small text-uppercase text-secondary border-bottom pb-2">Batch Compliance Status</h6>
                    
                    <div className="table-responsive">
                      <table className="table table-sm table-borderless align-middle mb-0">
                        <thead className="text-muted tiny-text">
                          <tr>
                            <th>COMPLIANCE-ITEM</th>
                            <th>REGULATION</th>
                            <th className="text-center">PASS</th>
                          </tr>
                        </thead>
                        <tbody className="small">
                          {compliance.map((c, i) => (
                            <tr key={i} className="border-bottom-subtle">
                              <td className="py-2 text-dark fw-medium">{c.item}</td>
                              <td className="py-2 text-muted">{c.regulation}</td>
                              <td className="py-2 text-center">
                                <div className="form-check form-switch d-inline-block">
                                  <input 
                                    className="form-check-input cursor-pointer" 
                                    type="checkbox" 
                                    role="switch"
                                    checked={c.status === "YES"} 
                                    onChange={(e) => toggleCompliance(i, e.target.checked)} 
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* SECTION 3: QUALITY REPORTS */}
              <div className="col-lg-6">
                <div className="card border-0 shadow-sm rounded-3 h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                        <h6 className="fw-bold mb-0 small text-uppercase text-secondary">Batch Reports</h6>
                        <div className="d-flex align-items-center gap-2">
                        <span className="tiny-text fw-bold text-muted text-uppercase">
                          Status
                        </span>
                        <select name="batchType" className="form-select form-select-sm w-auto border-0 bg-primary bg-opacity-10 text-primary fw-bold" value={formData.batchType} onChange={handleChange}>
                           <option value="ORGANIC">ORGANIC</option>
                           <option value="CONVENTIONAL">CONVENTIONAL</option>
                        </select>
                    </div>
                    </div>
                    <div className="row g-3">
                      {reportFields.map(r => {
                          const hasFile = existingReports[r.id];

                          return (
                            <div className="col-md-6" key={r.id}>
                              <div className={`p-2 border rounded ${hasFile ? "bg-success bg-opacity-10 border-success" : "bg-light"}`}>
                                
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <label className="tiny-text fw-bold text-muted">{r.label}</label>

                                  {hasFile && (
                                    <span className="badge bg-success">Uploaded</span>
                                  )}
                                </div>

                                {hasFile && (
                                  <div className="mb-2">
                                    <a
                                      href={hasFile}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="small text-success fw-bold"
                                    >
                                      View PDF
                                    </a>
                                  </div>
                                )}

                                <input
                                  type="file"
                                  className="form-control form-control-sm border-0 bg-white"
                                  onChange={(e) => handleFile(r.id, e.target.files[0])}
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER ACTIONS */}
            <div className="d-flex gap-3 mt-4 justify-content-end border-top pt-4">
              <button type="button" className="btn btn-light px-4 fw-bold text-muted rounded-pill" onClick={closeForm}>
                Discard Changes
              </button>
              <button className="btn btn-primary px-5 fw-bold rounded-pill shadow-sm" disabled={loading}>
                {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</> : "ADD Batch"}
              </button>
            </div>
                   {error && <div className="alert alert-danger border-0 shadow-sm small py-2 mb-4">{error}</div>}
          </form>
        </div>
      </div>
      <style>{`
        .tiny-text { font-size: 0.65rem; letter-spacing: 0.8px; }
        .cursor-pointer { cursor: pointer; }
        .border-bottom-subtle { border-bottom: 1px solid rgba(0,0,0,0.05); }
        .form-check-input:checked { background-color: #198754; border-color: #198754; }
        .form-control:focus, .form-select:focus { border-color: #0d6efd; box-shadow: none; background-color: #fff !important; }
        .modal-body::-webkit-scrollbar { width: 6px; }
        .modal-body::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
      `}</style>
    </div>
  );
}